export default {"src":"/_next/static/media/logo_mindteacher.a69359bd.svg","height":53,"width":60};